import {immerable} from "immer";
import FileType from "@/models/enums/file-type.ts";

class FileDataCreationModel {
    [immerable] = true;
    
    id: string;

    name: string;

    revision: number;
    
    fileType: FileType;
    
    relativePath = '';
    
    fileMetaObject = '';
    
    constructor(name: string, fileType: FileType = FileType.File2D) {
        this.id = crypto.randomUUID();
        this.name = name;
        this.revision = 0;
        this.fileType = fileType;
    }
}

export default FileDataCreationModel;